import type { FC } from 'react';
import { useEffect } from 'react';

import { Helmet } from 'react-helmet';

import { DashboardEvent } from 'features/dashboard/lib/constants';
import { trackEvent } from 'shared/lib/analytics/trackEvent';
import { useAuth } from 'shared/lib/auth/useAuth';
import { useFeatures } from 'shared/lib/features/useFeatures';

export const HubspotChat: FC = () => {
  const { isAuthenticated, user } = useAuth();
  const { isLoading } = useFeatures();

  useEffect(() => {
    const handleHubspotMessage = (event: MessageEvent) => {
      if (event.origin !== 'https://app.hubspot.com') {
        return;
      }

      try {
        const data = JSON.parse(event.data);
        if (data.type === 'open-change' && data.data?.isOpen === true) {
          trackEvent(DashboardEvent.SUPPORT_CHAT_CLICK);
        }
      } catch {}
    };

    window.hsConversationsSettings = {
      loadImmediately: false,
      identificationToken: user?.hubspot_identification_token,
      identificationEmail: user?.email,
    };

    window.hsConversationsOnReady = [];
    window.hsConversationsOnReady.push(() => {
      if (user && !user?.hubspot_identification_token) {
        console.error(
          'No hubspot identification token from the profile. User is going to be anonymous in Hubspot live chat',
        );
      }

      window.HubSpotConversations?.widget.load();
    });

    window.addEventListener('message', handleHubspotMessage);

    return () => {
      window.removeEventListener('message', handleHubspotMessage);
    };
  }, [user]);

  if (!isAuthenticated || !import.meta.env.VITE_APP_HUBSPOT_ID || isLoading) {
    return null;
  }

  return (
    <Helmet>
      <script
        async
        defer
        id="hs-script-loader"
        src={`https://js.hs-scripts.com/${import.meta.env.VITE_APP_HUBSPOT_ID}.js`}
      />
    </Helmet>
  );
};
